module.exports = require(`./method/${process.env.REACT_APP_RUN_MODE}`);
//module.exports = require(`./method/test`);